import { FC, useState } from 'react'
import { StyleSheet } from 'react-native'
import { Button, Text } from 'react-native-paper'
import ArrowRight from '../../../assets/icons/arrow-right.svg'
import { ColorsEnum } from '../../constants/colors'
import { FontsEnum } from '../../constants/fonts'
import { performHaptics } from '../../utils/performHaptics'

interface UpdateStateButtonProps {
    children: string
    onPress: () => void
}

const UpdateStateButton: FC<UpdateStateButtonProps> = ({ children, onPress }) => {
    const [isLoading, setIsLoading] = useState(false)

    const handlePress = async () => {
        performHaptics()

        setIsLoading(true)

        await onPress()

        setIsLoading(false)
    }

    return (
        <Button
            loading={isLoading}
            mode="contained"
            buttonColor={ColorsEnum.SECONDARY_DARK}
            onPress={handlePress}
            contentStyle={styles.buttonContent}
            style={styles.button}
            icon={ArrowRight}
        >
            <Text style={styles.text}>{children}</Text>
        </Button>
    )
}

const styles = StyleSheet.create({
    button: {
        borderTopStartRadius: 0,
        borderTopEndRadius: 0,
    },
    buttonContent: {
        flexDirection: 'row-reverse',
        paddingVertical: 6,
    },
    text: {
        color: '#FFFFFF',
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 15,
    },
})

export default UpdateStateButton
